var map = {
	"./ar.json": [
		5310,
		310
	],
	"./bn.json": [
		7581,
		581
	],
	"./de.json": [
		5894,
		894
	],
	"./en.json": [
		4174,
		174
	],
	"./es.json": [
		6725,
		725
	],
	"./fa.json": [
		3248,
		248
	],
	"./fr.json": [
		4605,
		605
	],
	"./hi.json": [
		3134,
		134
	],
	"./id.json": [
		5176,
		176
	],
	"./it.json": [
		3672,
		672
	],
	"./ja.json": [
		7980,
		980
	],
	"./ko.json": [
		9423,
		423
	],
	"./nl.json": [
		4943,
		943
	],
	"./pl.json": [
		1029,
		29
	],
	"./pt.json": [
		7741,
		741
	],
	"./ru.json": [
		4600,
		600
	],
	"./tr.json": [
		9755,
		755
	],
	"./vi.json": [
		1496,
		496
	],
	"./zh-Hans.json": [
		4742,
		742
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;